import FuseNavigation from '@fuse/core/FuseNavigation';
import clsx from 'clsx';
import { memo, useMemo, useEffect } from 'react';
import useAuthUser from '../../hooks/useAuthUser';
import DKBanner from 'app/shared-components/dk-banner/DKBanner';
import GetStartedPopup from 'app/shared-components/getStartedPopup/GetStartedPopup';
import useEnhancedUserNavigation from 'src/app/hooks/useEnhancedUserNavigation';
import { useCurrentMerchant } from 'src/app/queries/merchant.queries';
import { is0420Merchant } from 'src/app/utils/mccUtils';
import { modalsManger } from 'src/app/shared-components/modals';
import useGetStartedDialogStore from 'app/store/getStartedDialogSlice';

interface NavigationProps {
  className?: string;
  layout?: string;
  dense?: boolean;
  active?: string;
}

function Navigation(props: NavigationProps) {
  const user = useAuthUser();
  const role = user?.role;
  const { openMerchantSupportPopup, openDialog } = useGetStartedDialogStore();
  const { data: merchantData, isLoading } = useCurrentMerchant({ enabled: role === 'merchant' });
  const isGetStartedCompleted = merchantData?.data?.isGetStartedCompleted ?? false;
  const merchantMcc = merchantData?.data?.mcc;
  const is0420MerchantUser = is0420Merchant(merchantMcc);

  useEffect(() => {
    if (role !== 'merchant' || isLoading || isGetStartedCompleted) return;

    if (is0420MerchantUser) {
      modalsManger.open('Merchant0420CapabilitiesModal').catch(console.error);
    } else {
      openDialog();
    }
  }, [role, isGetStartedCompleted, isLoading, is0420MerchantUser, openDialog]);

  const handleItemClick = (item) => {
    if (item.onClick === 'openMerchantSupportPopup') {
      // Don't open Get Started pop-up for 0420 merchants (MCC ID 1)
      if (!is0420MerchantUser) {
        openDialog();
      }
    }
  };

  const userNavigation = useEnhancedUserNavigation(role);

  return useMemo(() => {
    return (
      <div className="flex flex-col justify-between h-full">
        <FuseNavigation
          className={clsx('navigation', props.className)}
          navigation={userNavigation}
          layout={props.layout}
          dense={props.dense}
          active={props.active}
          onItemClick={handleItemClick}
        />
        {role === 'merchant' && <DKBanner />}
        {role === 'merchant' && <GetStartedPopup />}
      </div>
    );
  }, [props.active, props.className, props.dense, props.layout, user, userNavigation]);
}

Navigation.defaultProps = {
  layout: 'vertical',
};

export default memo(Navigation);
